//When AD is failed more than max attempts times, Eligibility check flow is automatically applied for failed component(s).
//So, the “most common” codes should be used: B101 for device, so it would be B102 for the holder and B038 for the pocket charger.

export default {
    FAILED_FLOW_DEVICE_INFERENCE_CODE: 'B038',
    FAILED_FLOW_HOLDER_INFERENCE_CODE: 'B102',
    FAILED_FLOW_HOLDER_INFERENCE_CODE_L1: 'B042',
};
